<template>
  <div class="button" data-comp="a-link">
    <h-slug :to="blok.link">
      {{ blok.text }}
    </h-slug>
  </div>
</template>

<script setup>
defineProps({
  blok: {
    type: Object,
    default: () => ({})
  }
});
</script>
